/** @format */
import React from "react";
import { MultiSelect } from "primereact/multiselect";
const SurveyFilter = ({
  surveyName,
  surveyNames,
  status,
  surveyStatuses,
  onFilterChangeHandler
}) => {
  return (
    <>
      <div className='field col-3 md:col-3'>
        <label htmlFor='selectedChannelsFilter'>Survey</label>
        <MultiSelect
          placeholder='Survey'
          value={surveyName}
          options={surveyNames}
          onChange={(e) => {
            onFilterChangeHandler(e.target.name, e.value ?? [])
          }}
          id='surveyName'
          name='surveyName'
          showClear
        />
      </div>
      <div className='field col-3 md:col-3'>
        <label htmlFor='selectedRegionsFilter'>Status</label>
        <MultiSelect
          value={status}
          placeholder='Status'
          options={surveyStatuses}
          id='status'
          name='status'
          onChange={(e) => {
            onFilterChangeHandler(e.target.name, e.value ?? [])
          }}
          showClear
        />
      </div>
    </>
  );
};

export default SurveyFilter;
